// Canvas drawing surface size in drawing-space pixels.
// Imported by Drawing, RoomPage, GalleryPage and layout helpers.
export const CANVAS_W = 980;
export const CANVAS_H = 600;

// Layout constants for the Drawing page chrome.
export const TOOLBAR_W = 36;
export const RIGHT_PANEL_W = 232;
export const CHAT_SIDEBAR_W = 180; // landscape mobile chat sidebar width
export const GAP_W = 3;
